import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { voltarPara } from "@/components/layout/VoltarAoMenu";

/** As páginas abertas pelo hub ganham "‹ Minha clínica" no topo. */
export const DA_CLINICA = voltarPara("/clinica", "Minha clínica");

export function Resumo({ children }: { children: ReactNode }) {
  return <p className="relative mt-4 text-[13px] font-medium text-zinc-700 dark:text-foreground">{children}</p>;
}

export function Selo({ children, tom = "zinc" }: { children: ReactNode; tom?: "zinc" | "amber" }) {
  return (
    <span
      className={cn(
        "rounded-full px-2 py-0.5 text-[10.5px] font-bold uppercase tracking-wide",
        tom === "amber" ? "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400" : "bg-zinc-100 text-zinc-500 dark:bg-muted dark:text-muted-foreground",
      )}
    >
      {children}
    </span>
  );
}
